import styled from "styled-components";
import { FlexDiv } from "@/components/Atoms/Box";
import Button from "@/components/Atoms/Button";
import Image from "@/components/Atoms/Image";
import Typography from "@/foundation/Typography/V2";

export const PartnerBox = styled(FlexDiv)`
  flex-wrap: wrap;
  margin: 0 -16px;
  @media only screen and (max-width: 1079px) {
    margin: 0 -8px;
    padding: 0 8px;
  }
  @media only screen and (max-width: 992px) {
    margin: 0;
  }
`;
export const PartnerItem = styled(FlexDiv)`
  width: 100%;
  position: relative;
  max-width: calc(33.33% - 32px);
  user-select: none;
  margin: 0 16px 48px;
  background-color: ${({ theme }) => theme.colors.white};
  padding: 32px;
  flex-direction: column;
  & * {
    transition: all 0.3s ease-in-out;
  }
  border: 2px solid ${({ theme }) => theme.colorsV2.blueGray.shade_100};
  border-radius: 32px;
  @media only screen and (max-width: 1079px) {
    max-width: calc(50% - 16px);
    margin: 0 8px 22px;
  }
  @media only screen and (max-width: 992px) {
    max-width: 100%;
    margin: 0 0 20px;
    padding: 24px;
    &:last-child {
      margin: 0 0 22px;
    }
  }
`;
export const ImageDiv = styled(FlexDiv)`
  align-items: center;
  justify-content: center;
  margin-top: 8px;
  margin-bottom: 24px;
  @media only screen and (max-width: 992px) {
    justify-content: flex-start;
    margin: 0 0 8px 0px;
  }
`;
export const ImageHolder = styled(Image)``;
export const ImageBox = styled(FlexDiv)`
  height: 100%;
  max-height: 40px;
  width: 100%;
  max-width: 154px;
  ${ImageHolder} {
    height: 100%;
    max-height: 100%;
    object-fit: contain;
    width: 100%;
  }
  @media only screen and (max-width: 992px) {
    max-width: 150px;
    ${ImageHolder} {
      object-fit: unset;
      width: auto;
      height: auto;
    }
  }
`;
export const PartnerTitle = styled(Typography)`
  color: ${({ theme }) => theme.colorsV2.gray.shade_800};
  text-align: center;
  @media only screen and (max-width: 992px) {
    text-align: left;
  }
`;
export const Price = styled(Typography)`
  color: ${({ theme }) => theme.colorsV2.gray.shade_800};
  font-size: 54px;
  line-height: 48px;
  font-family: var(--man-400);
  letter-spacing: -0.04em;
  @media only screen and (max-width: 992px) {
    font-size: 30px;
    line-height: 40px;
    font-family: var(--man-700);
  }
`;
export const Currency = styled(Typography)`
  color: ${({ theme }) => theme.colorsV2.gray.shade_800};
  margin-right: 8px;
`;
export const PartnerLocation = styled(Typography)`
  color: ${({ theme }) => theme.colorsV2.gray.shade_500};
  margin-top: 8px;
  text-align: center;
  @media only screen and (max-width: 992px) {
    text-align: left;
    margin-top: 0;
  }
`;
export const PartnerDetailBox = styled(FlexDiv)`
  align-items: center;
  flex-direction: column;
  margin-bottom: 24px;
  @media only screen and (max-width: 992px) {
    align-items: flex-start;
  }
`;
export const PartnerPriceBox = styled(FlexDiv)`
  align-items: flex-start;
  justify-content: center;
  margin-bottom: 24px;
`;
export const CtaBox = styled(PartnerDetailBox)`
  flex: 1;
  justify-content: flex-end;
  margin-bottom: 0;
  @media only screen and (max-width: 992px) {
    align-items: flex-start;
  }
`;
export const CtaBtn = styled(Button)`
  border: 0;
  min-height: 48px;
  background-color: ${({ theme }) => theme.colorsV2.shyft.purple_text};
  &:hover {
    background-color: ${({ theme }) => theme.colorsV2.shyft.purple_text};
  }
  &:disabled,
  &:disabled&:hover {
    background: ${({ theme }) => theme.colorsV2.shyft.purple_text}b8 !important;
  }
  padding: 12px 32px;
  border-radius: 56px;
  min-width: 225px;
  @media only screen and (max-width: 992px) {
    min-width: 148px;
  }
`;
export const MiddleBox = styled(FlexDiv)`
  flex-direction: column;
  @media only screen and (max-width: 992px) {
    flex-direction: row;
    margin-bottom: 8px;
    align-items: center;
    ${PartnerDetailBox} {
      margin-bottom: 0;
      margin-right: 24px;
      flex: 1;
    }
    ${PartnerPriceBox} {
      margin-bottom: 0;
    }
  }
`;

export const Tag = styled(Typography)`
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, -50%);
  color: ${({ theme, color }) => color || theme?.colorsV2?.gray?.shade_900};
  background-color: ${({ backgroundColor }) => backgroundColor || "#ffdd2c"};
  border: 1px solid ${({ theme }) => theme?.colorsV2?.warning?.shade_300};
  padding: 4px 16px;
  text-transform: uppercase;
  border-radius: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: max-content;
`;

export const TagIcon = styled(Image)`
  height: 16px;
  width: 16px;
  margin-right: 8px;
`;
